import { IStorageType } from './../entities/storage-node';
import { DataService } from "./data-service";

class StorageTypeService extends DataService {
    getStorageTypes() {
        return this.api.get<IStorageType[]>(`storagetype`);
    }
}

export const storageTypeService = new StorageTypeService();